var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-popup',{attrs:{"fullscreen":"","title":"Terms And Conditions","active":_vm.isOpenTerms},on:{"update:active":function($event){_vm.isOpenTerms=$event}}},[_c('vx-pdf',{key:_vm.fileURL,attrs:{"src":_vm.fileURL}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }